import React from 'react';
import './landingPage.css';
import Grid from '@mui/material/Grid'
import congVang from '../../assets/images/Golden-Bridge.jpg';

import { useTranslation } from 'react-i18next';
import '../../i18n';

const Intro = () => {
        const { t } = useTranslation();
        return (
            <section className="beige-section" id="aboutUS">
            <div className="container-fluid" >
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                    <h2 className="big-heading">{t('landingPage:intro.intro-title')}</h2>
                    <p>{t('landingPage:intro.intro-context')}</p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <img src={congVang} alt="logo" width="80%"/>
                </Grid>
            </Grid>
            </div>
        </section>
)}

export default Intro;


